/**
 * Version Service — Xyden Leadership Assessment Platform
 * Step 6F Green Phase
 */

import { apiClient } from '../apiClient';
import type { Version } from '../../types';

export const versionService = {
  async getAll(): Promise<Version[]> {
    const res = await apiClient.get<{ data: Version[]; pagination: unknown }>('/api/versions');
    return res.data;
  },

  async getById(id: string): Promise<Version> {
    return apiClient.get<Version>((`/api/versions/${id}`));
  },

  async create(data: { version_name: string; changelog_notes: string }): Promise<Version> {
    const result = await apiClient.post<Version>(('/api/versions'), data);
    // Ensure state is Draft for created versions
    return { ...result, state: result.state ?? 'Draft' } as Version;
  },

  async update(id: string, data: Partial<Version>): Promise<Version> {
    return apiClient.put<Version>((`/api/versions/${id}`), data);
  },

  async publish(id: string): Promise<Version> {
    return apiClient.post<Version>((`/api/versions/${id}/publish`));
  },

  async clone(id: string): Promise<Version> {
    return apiClient.post<Version>((`/api/versions/${id}/clone`));
  },
};

export default versionService;
